// @flow

import * as React from 'react';

import { localize } from '@ta/common.i18n';
// eslint-disable-next-line no-restricted-imports
import { getStore } from '@ta/common.state';
import trackEventAJAX from '@ta/common.tracking';
import { Opener } from '@ta/overlays.managers';
import type { UgcAction } from '@ta/social.ugc-actions';
import { LabeledIconAction } from '@ta/public.listing';
import { SocialLoginGate } from '@ta/social.login-gate';
import { InteractionLogger } from '@ta/tracking.interactions';

import styles from './UgcActionSection.less';

type Props = {|
  actions: UgcAction[],
|};

const UgcActionListing = (props: UgcAction) => {
  const { label, icon, trackingName = undefined, onClick } = props;
  const state = getStore().getState();

  if (props.url) {
    const { url } = props;
    return (
      <SocialLoginGate pid={props.loginPid}>
        {loginGate => (
          <InteractionLogger>
            {logClick => {
              const gatedTrackedOnClick = (event: SyntheticMouseEvent<*>) => {
                if (trackingName !== undefined) {
                  logClick(event, 'postContentCtaClick', {
                    action: trackingName,
                    entrypoint: 'ACTION_CARD',
                    isMemberSignedIn: state?.auth?.isMember,
                  });
                  trackEventAJAX({
                    module: 'postContentCtaClick',
                    action: trackingName,
                    context: `ACTION_CARD|${state?.route?.page}`,
                    isMemberSignedIn: state?.auth?.isMember,
                  });
                }
                event.preventDefault();
                loginGate().then(() => {
                  if (onClick) {
                    onClick(event);
                  }
                  // eslint-disable-next-line no-restricted-globals
                  window.location.href = url;
                });
              };
              return (
                <LabeledIconAction
                  icon={icon}
                  label={label}
                  url={url}
                  onClick={gatedTrackedOnClick}
                />
              );
            }}
          </InteractionLogger>
        )}
      </SocialLoginGate>
    );
  }
  if (props.name) {
    const { name, overlay } = props;
    return (
      <React.Fragment>
        {overlay()}
        <Opener name={name}>
          {open => (
            <SocialLoginGate pid={props.loginPid}>
              {loginGate => (
                <InteractionLogger>
                  {logClick => {
                    const openAndClick = event => {
                      if (trackingName !== undefined) {
                        logClick(event, 'postContentCtaClick', {
                          action: trackingName,
                          entrypoint: 'ACTION_CARD',
                          isMemberSignedIn: state?.auth?.isMember,
                        });
                        trackEventAJAX({
                          module: 'postContentCtaClick',
                          action: trackingName,
                          context: `ACTION_CARD|${state?.route?.page}`,
                          isMemberSignedIn: state?.auth?.isMember,
                        });
                      }
                      loginGate().then(() => {
                        // Change the PID to the real PID of the product
                        global.require(['trjs!ta/util/Cookie'], Cookie => {
                          Cookie.setPIDCookie(props.pid);
                        });

                        open();
                        if (onClick) {
                          onClick(event);
                        }
                      });
                    };
                    return <LabeledIconAction icon={icon} label={label} onClick={openAndClick} />;
                  }}
                </InteractionLogger>
              )}
            </SocialLoginGate>
          )}
        </Opener>
      </React.Fragment>
    );
  }
  return null;
};

UgcActionListing.defaultProps = { onClick: undefined };

const UgcActionSection = ({ actions }: Props) => (
  <div className={`${styles.section} ui_card section`}>
    <div className={styles.header}>{localize('social_profile_ugc_cta')}</div>
    {actions.map(action => (
      <UgcActionListing {...action} key={action.label} />
    ))}
  </div>
);

export default UgcActionSection;
